var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}}),_c('div',{staticClass:"falinn"},[_vm._v("HÞ.")]),_c('HelloWorld',{attrs:{"msg":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }